export default {"src":"/_next/static/media/icon-inclusion.d5dca19b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};